<script src="../../api/set/jxcgoodscategory.js"></script>
<template>
    <div id="app">
        <el-container>
            <el-header :style="backimg">
                <Header/>
            </el-header>
            <el-container v-if="loaduserinfo">
                <el-main>
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
    import Header from './Header'
    import {getUserByToken,timingDevice} from '@/api/login'
    import {getListData} from '@/api/set/jxcgoodscategory'
    export default {
      name: 'Index',
      data() {
        return {
          backimg: '',
          loaduserinfo: false,
          tokenLoading: false
        }
      },
      beforeCreate() {
        var appguid = this.$route.query.appguid;
        if (appguid) {
          localStorage.setItem("appguid", appguid);
        }
        var token = this.$route.query.token;
        var tenantid = this.$route.query.tenantid;
        if (tenantid) {
          localStorage.setItem("tenantid", tenantid);
        }
        //由其他应用跳转过来，根据token获取其他信息
        if (appguid && token) {
          localStorage.setItem("hpapi_token", token);
          this.tokenLoading = true;
          getUserByToken({token: token}).then(response => {
            //加载完用户信息，显示iframe内容
            this.loaduserinfo = true;
            this.tokenLoading = false;

            var tokenInfo=response.data.tokenModel;
            var tenantDoOld = tokenInfo.tenantDO;
            var tenantDoNew =[]
            var duliSite='hoya100.eyes.wang';
            if(window.location.host==duliSite) {
              for (var i in tenantDoOld) {
                if (tenantDoOld[i].website == duliSite) {
                  tenantDoNew.push(tenantDoOld[i]);
                }
              }
            }else{
              for (var i in tenantDoOld) {
                if (tenantDoOld[i].website != duliSite) {
                  tenantDoNew.push(tenantDoOld[i]);
                }
              }
            }
            tokenInfo.tenantDO=tenantDoNew;

            localStorage.setItem("hpapi_tokenModel", JSON.stringify(tokenInfo));
            localStorage.setItem("hpapi_userInfoModel", JSON.stringify(response.data.userInfoModel));
            var loginApp = tokenInfo.tenantDO.filter(element => {
              return element.appguid == appguid && element.unitguid == response.data.userInfoModel.tenantid;
            });
            //设置标题
            if (loginApp.length) {
              document.title = loginApp[0].tenantname + "【" + loginApp[0].appname + "】";
            }
          });
        }
        else {
          this.loaduserinfo = true;
        }
      },
      mounted() {
        //定时执行代码
        timingDevice();

        if (localStorage.getItem("hpapi_tokenModel") && !this.tokenLoading) {
          this.loaduserinfo = true;
        }
        // if (localStorage.getItem("zyjthemecssurl")) {
        //   this.backimg = 'height: 48px;background-size: cover;background-image: url(/static/img/login/head-essilor.jpg)';background-size: cover;background-image: url(/static/img/login/head-bac.jpg)
        // } else
          this.backimg = 'height: 48px; background-color:#165ACC ';

        var usermodel=true;
        getListData({categorylenght:3}).then(response=> {
          var cats = response.data.obj.rows
          var hasframe = false;
          for (let i in cats) {
            if (cats[i].categorycode == '002' || cats[i].categorycode == '003') {
              hasframe = true;
              break;
            }
          }
          usermodel = hasframe;
          localStorage.setItem("hpapi_usemodel", usermodel ? '' : 'noframe');
        })
      },
      components: {
        "Header": Header
      }
    }
</script>

<style scoped>

    .el-main {
        padding: 0px;
        height: calc(100vh - 48px);
        /*background-color: red;*/
        width: 100%;
        overflow: auto;
    }

    .el-header {
      min-width: 1300px;
      padding: 0px;
      height: 48px;
      margin: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/index/Index.vue